import { StocksExchangeCheckoutAction } from './stocks-exchange-checkout.action';
import { StockCheckoutType } from '@toro/common/shared/models/stocks-exchange/stock-checkout.model';
import { InitializerAction } from '@toro/common/shared/state-management/initializer/initiliazer.action';
import { StorageService } from '@toro/common/shared/services/storage.service';

const loadStockCheckoutItemFromStore = () => {
    const stockItem = StorageService.getSessionItem('stockCheckoutItem');
    if (!!stockItem) {
        StorageService.removeSessionItem('stockCheckoutItem');
        return JSON.parse(stockItem);
    }
    return stockItem;
}
export class StocksExchangeCheckoutState {
    order: any;
    strategy: any;
    stockCheckout: StockCheckoutType;
    workingDays: Array<string>;
};

export const initialState: StocksExchangeCheckoutState = {
    order: null,
    strategy: null,
    stockCheckout: loadStockCheckoutItemFromStore(),
    workingDays: [],
};

export function StocksExchangeCheckoutReducer(state: StocksExchangeCheckoutState = initialState, action?: StocksExchangeCheckoutAction){

    switch (action.type) {
        //busca ordens
        case StocksExchangeCheckoutAction.newOrder:
            return { ...state, ...{ pending: true } };
        case StocksExchangeCheckoutAction.newOrderError:
            return { ...state, ...{ pending: false, error: action.payload } }
        case StocksExchangeCheckoutAction.newOrderSuccess:
            return { ...state, ...{ order: action.payload, pending: false } };

        case StocksExchangeCheckoutAction.editOrder:
            return { ...state, ...{ pending: true } };
        case StocksExchangeCheckoutAction.editOrderError:
            return { ...state, ...{ pending: false, error: action.payload } }
        case StocksExchangeCheckoutAction.editOrderSuccess:
            return { ...state, ...{ order: action.payload, pending: false } };

        case StocksExchangeCheckoutAction.newStrategy:
            return { ...state, ...{ pending: true } };
        case StocksExchangeCheckoutAction.newStrategyError:
            return { ...state, ...{ pending: false, error: action.payload } }
        case StocksExchangeCheckoutAction.newStrategySuccess:
            return { ...state, ...{ strategy: action.payload, pending: false } };

        case StocksExchangeCheckoutAction.editStrategy:
            return { ...state, ...{ pending: true } };
        case StocksExchangeCheckoutAction.editStrategyError:
            return { ...state, ...{ pending: false, error: action.payload } }
        case StocksExchangeCheckoutAction.editStrategySuccess:
            return { ...state, ...{ strategy: action.payload, pending: false } };

        case StocksExchangeCheckoutAction.shutDownStrategy:
            return { ...state, ...{ pending: true } };
        case StocksExchangeCheckoutAction.shutDownStrategyError:
            return { ...state, ...{ pending: false, error: action.payload } }
        case StocksExchangeCheckoutAction.shutDownStrategySuccess:
            return { ...state, ...{ pending: false } };

        case StocksExchangeCheckoutAction.nextWorkingDays:
            return { ...state, ...{ pending: true } };
        case StocksExchangeCheckoutAction.nextWorkingDaysError:
            return { ...state, ...{ pending: false, error: action.payload } }
        case StocksExchangeCheckoutAction.nextWorkingDaysSuccess:
            return { ...state, ...{ pending: false , workingDays: action.payload } };

        case StocksExchangeCheckoutAction.setStockCheckout:
            return { ...state, ...{stockCheckout: action.payload} }
            
        case InitializerAction.resetUserRelatedData:
            return initialState;
            
        default:
            return state;
    }
};
